import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useQuery } from '@tanstack/react-query';

export function useSummaryData({ electricalProjectVersionId }: { electricalProjectVersionId: string }) {
    const recap = useQuery(elektraAppQueryOptions.project.recapViewOptions({
        electricalProjectVersionId,
    }));

    return {
        summary: recap.data?.Summary,
        reports: recap.data?.Summary?.Reports ?? [],
        isLoading: recap.isLoading,
        isError: recap.isError,
    };
}
